import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
 import flatten from 'lodash-es/flatten';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ApiUrlConstants } from './app/common/constants/api.constants';
import { SSO } from './app/sso/sso.constants';
import 'whatwg-fetch';
import { StoreConfig } from './app/shared/interfaces/store-config.interface';
import { CookieService } from 'ngx-cookie-service';
import 'url-polyfill';
import { CacheKey } from './app/shared/constants/cachekey.constants';
import { AppConstants } from './app/common/constants/app.constants';
import { PortalCountry } from './app/shared/interfaces/portal-country.interface';
import { Country } from './app/shared/interfaces/country.interface';
import { MenuPortal } from './app/shared/enums/menu-portal.enum';
import { Member } from './app/shared/interfaces/member.interface';
import { Language } from './app/shared/interfaces/language.interface';
import { UserSession } from './app/shared/interfaces/usersession.interface';
import { TokenType } from './app/shared/enums/token-type.enum';
import { MemberType } from './app/shared/enums/member-type.enum';
import { EncryptionService } from './app/sso/encryption.service';
import { SharedConstants } from './app/shared/constants/shared.constants';
import { WholesaleQualifiedResponse } from './app/shared/interfaces/wholesaleQualifiedResponse.interface';
import { DisplayDirection } from './app/shared/constants/display-direction';
import { MemberLevel } from './app/shared/enums/member-level.enum';
import IdTokenVerifier from 'idtoken-verifier';
import { DiscountPercentageResponse } from './app/shared/interfaces/discount-percentage.response.interface';
import { createOfflineCompileUrlResolver } from '@angular/compiler';
import { StorePortalFeature } from './app/shared/interfaces/privilege.interface';
import { Portals } from './app/common/enums/portal.enum';
import { MemberTitleAliasResponse } from './app/shared/interfaces/memberTitle-alias.response.interface';
import { MemberOrderRestrictionResponse } from './app/shared/interfaces/member-order-restriction.response';
import { MemberOrderLevelHistory } from './app/shared/interfaces/member-order-level-history.response';
import { MemberOrderType } from './app/shared/enums/member-order-type.enum';
import { CountryMetaData } from './app/shared/interfaces/CountryMetaData.interface';
if (environment.production) {
  enableProdMode();
}

declare let userLoginStatus: any;
declare let loggedInMemberId: any;
declare let apiConfig: any;
declare var canShowSplashInitally: any;
declare let data: any;

// const IdTokenVerifier = require('idtoken-verifier');
const cookieService: CookieService = new CookieService(document);
const cookieExpiryDate: Date = new Date((new Date()).valueOf() + 1000 * 60 * 60 * 24 * environment.cookieExpiryDays);
let countries: Country[] = [];
let storePortalFeaturesLoaded = false;
function errorHandle(error: any) {
  if (localStorage.getItem('appcoporate.' + error)) {
    const error_count = JSON.parse(localStorage.getItem('appcoporate.' + error));
    if (error_count >= 3) {
      localStorage.clear();
      if (document.readyState !== 'loading') {
        document.getElementById('error').style.display = 'block';
        document.getElementById(error).style.display = 'block';
        document.getElementById('progressBar').style.display = 'none';

      } else {
        document.addEventListener('DOMContentLoaded', function (event) {
          document.getElementById('error').style.display = 'block';
          document.getElementById(error).style.display = 'block';
          document.getElementById('progressBar').style.display = 'none';
        });
      }
    } else {
      localStorage.setItem('appcoporate.' + error, JSON.stringify(error_count + 1));
      if (error === 'introspect_error') {
        if (getStoredToken(TokenType.REFRESH_TOKEN)) {
          validateRefreshToken();
        } else {
          loginProcess();
        }
      } else {
        redirect(false);
      }
    }
  } else {
    localStorage.setItem('appcoporate.' + error, JSON.stringify(1));
    if (error === 'introspect_error') {
      if (getStoredToken(TokenType.REFRESH_TOKEN)) {
        validateRefreshToken();
      } else {
        loginProcess();
      }
    } else {
      redirect(false);
    }
  }
}

const validateUserStatus = function () {
  // Step 1: Member guid cookie validation
  const memberSessionGuid = cookieService.get(SSO.MEMBER_SESSIONID);
  if (memberSessionGuid !== undefined && memberSessionGuid !== null && memberSessionGuid !== '') {
    // Step 2: When member guid is available, check for EPAT (External portal Access Token)
    const accessToken = getStoredToken(TokenType.ACCESS_TOKEN);
    if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
      // Step 3: If EPAT is availale, trigger the introspect call to SSO
      validateAccessToken(false, '');
    } else {
      // Step 4: if EPAT is not available, use member guid to get the EPAT and EPRT and save into localstorage
      getAccessTokendetails(memberSessionGuid);
    }
    // Step 4: if EPAT is not available, use member guid to get the EPAT and EPRT and save into localstorage
    // Step 5: Trigger introspect
    // Step 6: if any information is not available, display login
  }
};

/**
 * Get User seesion details from API
 */
const getUserSessionDetails = function () {
  const memberSessionGuid = cookieService.get(SSO.MEMBER_SESSIONID);
  if (memberSessionGuid !== undefined && memberSessionGuid !== null && memberSessionGuid !== '') {
    getAccessTokendetails(memberSessionGuid);
  }
};

/**
 * Check whether store is a report only country or not
 * @param storeConfig 
 */
const reportOnlyStore = (storeConfig) => {
  if (storeConfig && storeConfig.portals !== undefined
    && storeConfig.portals !== null && storeConfig.portals.length > 0) {
    const hasAllPortalMapping = storeConfig.portals
      .findIndex(m => m.id === Portals.All) == -1 ? false : true;
    const hasShopPortalAccess = storeConfig.portals
      .findIndex(m => m.id === Portals.Shop) == -1 ? false : true;
    const hasJoinPortalAccess = storeConfig.portals
      .findIndex(m => m.id === Portals.Join) == -1 ? false : true;
    const hasReportsPortalAccess = storeConfig.portals
      .findIndex(m => m.id === Portals.Reports) == -1 ? false : true;
    if (!hasAllPortalMapping && hasReportsPortalAccess && !(hasShopPortalAccess || hasJoinPortalAccess)) {
      return true;
    }
  }
  return false;
}

/**
 * Save accesstoken
 * @param tokenInfo
 */
const saveAccessToken = function (userSession: UserSession, isRedirect: boolean, navPath: string) {
  const accountServiceUrl = ApiUrlConstants.accountApiUrl + '/sessions';
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  const requestInit = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(userSession)
  };
  fetch(accountServiceUrl, requestInit)
    .then(
      function (response: any) {
        if (response && response.status !== 404) {
          response.json().then(function (sessionDetails: any) {
            // Save the tokens into local storage
            localStorage.setItem(SSO.ACCESS_TOKEN, sessionDetails.accessToken);
            localStorage.setItem(SSO.REFRESH_TOKEN, sessionDetails.refreshToken);
            localStorage.setItem(SSO.IS_NEW_TOKEN, 'false');
            if (isRedirect) {
              redirection(navPath);
            }
          });
        }
      });
};

/**
 * Get Access token details based on guid
 * @param guid
 */
const getAccessTokendetails = function (guid: string) {
  const accountServiceUrl = ApiUrlConstants.accountApiUrl + '/sessions/' + guid;
  const myHeaders = new Headers();
  const requestInit = {
    method: 'GET',
    headers: myHeaders
  };
  fetch(accountServiceUrl, requestInit)
    .then(
      function (response: any) {
        if (response && response.status !== 404) {
          response.json().then(function (sessionDetails: any) {
            if (sessionDetails && sessionDetails.accessToken !== null
              && sessionDetails.accessToken !== undefined && sessionDetails.accessToken !== '') {
              // Save the tokens into local storage
              localStorage.setItem(SSO.ACCESS_TOKEN, sessionDetails.accessToken);
              localStorage.setItem(SSO.REFRESH_TOKEN, sessionDetails.refreshToken);
              localStorage.setItem(SSO.LOCAL_MEMBER_SESSION_ID, guid);
              localStorage.setItem(SSO.IS_NEW_TOKEN, 'false');
            } else {
              removeSessionCookieAndTokens();
            }
            tokenCheck(false);
          });
        } else {
          removeSessionCookieAndTokens();
          tokenCheck(false);
        }
      }).catch(function (err: any) {
        removeSessionCookieAndTokens();
        tokenCheck(false);
      });
};

function removeSessionCookieAndTokens() {
  cookieService.delete(SSO.MEMBER_ID, apiConfig.cookiePath, apiConfig.cookieDomain);
  cookieService.delete(SSO.MEMBER_SESSIONID, apiConfig.cookiePath, apiConfig.cookieDomain);
  localStorage.removeItem(SSO.ACCESS_TOKEN);
  localStorage.removeItem(SSO.REFRESH_TOKEN);
  localStorage.removeItem(SSO.LOCAL_MEMBER_SESSION_ID);
  localStorage.removeItem(SSO.IS_NEW_TOKEN);
}

const constructUserSession = function (accessToken: string, refreshToken: string, uuid: string): UserSession {
  const userSession: UserSession = {
    accessToken: accessToken,
    refreshToken: refreshToken,
    environment: environment.envName,
    guid: uuid
  };
  return userSession;
};

function getBetaCountries() {
  let betaCountries: Array<string> = [];
  if (environment.betaEnabledCountries !== undefined && environment.betaEnabledCountries !== null
    && environment.betaEnabledCountries !== '') {
    betaCountries = environment.betaEnabledCountries.toLowerCase().split(',');
  }
  return betaCountries;
}

function validateBetaCountryConfig(countryCode: string) {
  if (environment.betaPortal === false && environment.betaEnabledCountries !== undefined && environment.betaEnabledCountries !== null
    && environment.betaEnabledCountries !== '') {
    let betaEnabledCountries: Array<string> = getBetaCountries();
    if (betaEnabledCountries.includes(countryCode.toLowerCase())) {
      countryCode = 'usa';
    }
  }
  return countryCode;
}

function getCountryInfo(countryCode: string) {
  const getConfigurationUrl = ApiUrlConstants.configurationApiUrl + 'countries/iso-code/' + countryCode;
  const myHeaders = new Headers();
  const uuid = SSO.getnonce();
  let headerValue = '';
  myHeaders.append('UUID', uuid);
  let token = localStorage.getItem('appcoporate.guestToken');
  if (token) {
    headerValue = 'Bearer ' + token + '&&3';
    if (environment.enableAuthorization) {
      myHeaders.append('Authorization', getAuthorizationHeader(headerValue, uuid));
    }
    if (environment.enableAuthentication) {
      myHeaders.append('Authentication', headerValue);
    }
  } else {
    token = getStoredToken(TokenType.ACCESS_TOKEN);
    headerValue = 'Bearer ' + token + '&&2';
    if (environment.enableAuthorization) {
      myHeaders.append('Authorization', getAuthorizationHeader(headerValue, uuid));
    }
    if (environment.enableAuthentication) {
      myHeaders.append('Authentication', headerValue);
    }
  }

  const myInit = {
    method: 'GET',
    headers: myHeaders
  };
  if (countryCode) {
    fetch(getConfigurationUrl, myInit)
      .then(
        function (res: any) {
          if (res && res.status !== 404) {
            res.json().then(function (res: any) {
              res.requestCountryCode = countryCode;
              localStorage.setItem('appcoporate.previewConfig', JSON.stringify(res));
              res.homeIsocodeThree = countryCode.toUpperCase();
              loadStoreConfiguration(res);
            }).catch(function (err: any) {
            });
          } else {
            setFallbackCountryAndLanguage();
          }
        });
  }
}

function getStoreConfiguration(countryCodeByIpInfo?: string) {
  let countryCode: string = countryCodeByIpInfo;
  const storedCountryCode: string = cookieService.get(CacheKey.countryCode);
  let modifyNavPath = false;
  const userInfo: any = JSON.parse(localStorage.getItem('appcoporate.userInfo'));
  if (userInfo && storedCountryCode && userInfo.memberAllowedCountries
    && userInfo.memberAllowedCountries.length > 0) {
    const selectedCountry = userInfo.memberAllowedCountries
      .find(x => x.isoCodeThree && (x.isoCodeThree.toLowerCase() === storedCountryCode.toLowerCase()));
    if (selectedCountry) {
      countryCode = selectedCountry.isoCodeThree;
    } else {
      modifyNavPath = true;
      countryCode = userInfo.homeCountryCode ? userInfo.homeCountryCode.toLowerCase() : countryCodeByIpInfo;
    }
  } else {
    countryCode = countryCodeByIpInfo || cookieService.get(CacheKey.countryCode);
  }
  const storeInfo: StoreConfig = JSON.parse(localStorage.getItem('appcoporate.StoreConfiguration'));
  if (!countryCode) {
    countryCode = countryCodeByIpInfo ? countryCodeByIpInfo : 'usa';
  }

  if (storeInfo && storeInfo.requestCountryCode && storeInfo.requestCountryCode.toUpperCase() === countryCode.toUpperCase()) {
    loadStoreConfiguration(storeInfo, modifyNavPath);
    cookieService.set(CacheKey.countryCode, countryCode, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
  } else {
    cookieService.set(CacheKey.countryCode, countryCode, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
    // const previewConfig: any = JSON.parse(localStorage.getItem('appcoporate.previewConfig'));
    let getConfigurationUrl;
    // if (!previewConfig || (previewConfig && previewConfig.titanPlatformEnabled)) {
    getConfigurationUrl = ApiUrlConstants.configurationApiUrl + 'store-countries/' + countryCode.toUpperCase();
    // } else {
    //   getConfigurationUrl = environment.uiTemplateBaseUrl + '/test/preview-store-config.json';
    // }
    const myHeaders = new Headers();
    const uuid = SSO.getnonce();
    let headerValue = '';
    myHeaders.append('UUID', uuid);
    let token = localStorage.getItem('appcoporate.guestToken');
    if (token) {
      headerValue = 'Bearer ' + token + '&&3';
      if (environment.enableAuthorization) {
        myHeaders.append('Authorization', getAuthorizationHeader(headerValue, uuid));
      }
      if (environment.enableAuthentication) {
        myHeaders.append('Authentication', headerValue);
      }
    } else {
      token = getStoredToken(TokenType.ACCESS_TOKEN);
      headerValue = 'Bearer ' + token + '&&2';
      if (environment.enableAuthorization) {
        myHeaders.append('Authorization', getAuthorizationHeader(headerValue, uuid));
      }
      if (environment.enableAuthentication) {
        myHeaders.append('Authentication', headerValue);
      }
    }

    const myInit = {
      method: 'GET',
      headers: myHeaders
    };
    fetch(getConfigurationUrl, myInit)
      .then(
        function (response: any) {
          if (response && response.status !== 404) {
            response.json().then(function (res: any) {
              res.requestCountryCode = countryCode;
              localStorage.removeItem('appcoporate.previewConfig');
              loadStoreConfiguration(res, modifyNavPath);
            })
              .catch(function (err: any) {
              });
          } else {
            getCountryInfo(countryCode);
          }
        });
  }
}

function getAuthorizationHeader(token: string, uuid: string) {
  const res = uuid + '||' + token;
  return EncryptionService.encryptText(res);
}

function setFallbackCountryAndLanguage() {
  cookieService.set(CacheKey.languageCode,
    AppConstants.fallbackLanguageCode, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
  cookieService.set(CacheKey.countryCode,
    AppConstants.fallbackCountryCode, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
  window.history.pushState(null, null, AppConstants.fallbackPath);
  window.location.reload();
}

function bootstrapModule(modifyNavPath) {
  if (data && data.bookmarkedUrl || modifyNavPath) {
    const countryCode = cookieService.get(CacheKey.countryCode);
    const langCode = cookieService.get(CacheKey.languageCode);
    window.history.replaceState(null, null, countryCode + '/' + langCode + '/home');
  }

  const userInfo: Member = JSON.parse(localStorage.getItem('appcoporate.userInfo'));
  const storeConfig: StoreConfig = JSON.parse(localStorage.getItem('appcoporate.StoreConfiguration'));
  reportOnlyStore(storeConfig);
  if (userInfo && storeConfig) {
    const transactionalWholeSaleQualified = userInfo.transactionalWholesaleQualified ? true : false;
    const transactionalOptin = userInfo.transactionalOptin ? true : false;
    if (storeConfig.memberAliasAvailable && userInfo.homeCountryCode) {
      getMemberTitleAlias(userInfo.homeCountryCode, storeConfig.id);
    } else {
      if (!reportOnlyStore(storeConfig)) {
        getDiscountPercentages(transactionalWholeSaleQualified, transactionalOptin, userInfo.memberTitleId, storeConfig.id);
      }
      else {
        bootstrap();
      }
    }
  } else {
    bootstrap();
  }
  if (document.readyState !== 'loading') {
    document.getElementById('showApp').style.display = 'block';
    document.getElementById('progressBar').style.display = 'none';
  } else {
    document.addEventListener('DOMContentLoaded', function (event) {
      document.getElementById('showApp').style.display = 'block';
      document.getElementById('progressBar').style.display = 'none';
    });
  }
}

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

/**
 * Get member order level history
 * @param userInfo
 * @param countryCode
 */
const getMemberOrderLevelHistory = async (userInfo: Member, countryCode: string) => {
  const storeInfo: any = JSON.parse(localStorage.getItem('appcoporate.StoreConfiguration'));
  const getURL = ApiUrlConstants.accountApiUrl + '/member/' + userInfo.memberId + '/country/' + storeInfo.countryId
    + '/member-rank-level-history';
  const myHeaders = constructHttpheaders();
  const myInit = {
    method: 'GET',
    headers: myHeaders,
  };
  fetch(getURL, myInit)
    .then(
      function (response: any) {
        if (response && response.status !== 404) {
          response.json().then(function (memberOrderLevelHistory: MemberOrderLevelHistory[]) {
            if (memberOrderLevelHistory && memberOrderLevelHistory.length && memberOrderLevelHistory[0]
              && memberOrderLevelHistory[0].memberTitleId === MemberLevel.PREFERREDCUSTOMER) {
              const memberOrderRestrictionInfo: MemberOrderRestrictionResponse = JSON.parse(
                localStorage.getItem('appcoporate.MemberOrderRestrictionInfo'));
              memberOrderRestrictionInfo.nextOrderEligible = true;
              localStorage.setItem('appcoporate.MemberOrderRestrictionInfo', JSON.stringify(memberOrderRestrictionInfo));
            }
            bootstrap();
          });
        } else {
          bootstrap();
        }
      }).catch(function (err: any) {
        bootstrap();
      });
};

/**
 * validate member order resriction info
 * @param memberOrderRestrictionInfo
 * @param userInfo
 */
function validateMemberOrderRestrictionInfo(memberOrderRestrictionInfo: MemberOrderRestrictionResponse, userInfo: Member) {
  let displayRestrictOrderNotification = false;
  if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
    && memberOrderRestrictionInfo && userInfo.enrollmentDate && !memberOrderRestrictionInfo.nextOrderEligible) {
    const restrictedDays = memberOrderRestrictionInfo.restrictedDays;
    const dateParts = userInfo.enrollmentDate.split('-');
    const enrollmentDate = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
    if (enrollmentDate && restrictedDays) {
      enrollmentDate.setHours(0, 0, 0, 0);
      enrollmentDate.setDate(enrollmentDate.getDate() + restrictedDays);
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      if (enrollmentDate.getTime() > currentDate.getTime()) {
        displayRestrictOrderNotification = true;
      }
    }
    return displayRestrictOrderNotification;
  }
}

/**
* Get member order restriction info
* @param wholesaleQualified
* @param optin
* @param memberTitleID
* @param storeId
*/
const getMemberOrderRestrictionsInfo = async () => {
  const userInfo: Member = JSON.parse(localStorage.getItem('appcoporate.userInfo'));
  const countryCode = cookieService.get(CacheKey.countryCode);
  if (userInfo && userInfo.memberTypeId === MemberType.DISTRIBUTOR
    && countryCode && countryCode.toLowerCase() === 'gbr') {
    const orderType = userInfo && userInfo.memberTitleId !== MemberLevel.RETAIL ? MemberOrderType.Wholesale
      : MemberOrderType.Retail;
    const memberTitleId = userInfo ? userInfo.memberTitleId : MemberLevel.RETAIL;
    const getURL = ApiUrlConstants.orderApiUrl + '/V1/member-order-restrictions?memberTitleId='
      + memberTitleId + '&countryCode=' + countryCode + '&orderType=' + orderType;
    const myHeaders = constructHttpheaders();
    const myInit = {
      method: 'GET',
      headers: myHeaders,
    };
    fetch(getURL, myInit)
      .then(
        function (response: any) {
          if (response && response.status !== 404) {
            response.json().then(function (memberOrderRestrictionInfo: MemberOrderRestrictionResponse) {
              if (memberOrderRestrictionInfo && memberOrderRestrictionInfo.restrictedDays) {
                localStorage.setItem('appcoporate.MemberOrderRestrictionInfo', JSON.stringify(memberOrderRestrictionInfo));
                const restrictOrder = validateMemberOrderRestrictionInfo(memberOrderRestrictionInfo, userInfo);
                if (restrictOrder) {
                  getMemberOrderLevelHistory(userInfo, countryCode);
                } else {
                  bootstrap();
                }
              } else {
                bootstrap();
              }
            });
          } else {
            bootstrap();
          }
        }).catch(function (err: any) {
          bootstrap();
        });
  } else {
    bootstrap();
  }
};

/**
* Get discount percentages
* @param wholesaleQualified
* @param optin
* @param memberTitleID
* @param storeId
*/
const getDiscountPercentages = async (wholesaleQualified: boolean, optin: boolean, memberTitleID: number, storeId: number) => {
  const confugurationServiceUrl = ApiUrlConstants.configurationApiUrl
    + 'discount-percentages?wholeSaleQualified=' + wholesaleQualified + '&optin=' + optin
    + '&memberTitleId=' + memberTitleID + '&storeId=' + storeId;
  const myHeaders = constructHttpheaders();
  const myInit = {
    method: 'GET',
    headers: myHeaders
  };
  fetch(confugurationServiceUrl, myInit)
    .then(
      function (response: any) {
        if (response && response.status !== 404) {
          response.json().then(function (discountPercentage: DiscountPercentageResponse) {
            if (discountPercentage) {
              localStorage.setItem('appcoporate.MemberDiscountPercentage', JSON.stringify(discountPercentage));
            }
          });
          getMemberOrderRestrictionsInfo();
        } else {
          getMemberOrderRestrictionsInfo();
        }
      }).catch(function (err: any) {
        getMemberOrderRestrictionsInfo();
      });
};

/**
 * Get MemberTitle Alias
 * @param homeCountryCode 
 * @param storeId 
 */

const getMemberTitleAlias = async (homeCountryCode: String, storeId: number) => {
  const confugurationServiceUrl = ApiUrlConstants.configurationApiUrl
    + 'stores/' + storeId + '/membertitle-alias-configs/' + homeCountryCode;
  const userInfo: Member = JSON.parse(localStorage.getItem('appcoporate.userInfo'));
  const myHeaders = constructHttpheaders();
  const myInit = {
    method: 'GET',
    headers: myHeaders,
  };
  const transactionalWholeSaleQualified = userInfo.transactionalWholesaleQualified ? true : false;
  const transactionalOptin = userInfo.transactionalOptin ? true : false;
  fetch(confugurationServiceUrl, myInit)
    .then(
      function (response: any) {
        if (response && response.status !== 404) {
          response.json().then(function (memberTitleAliasResponse: MemberTitleAliasResponse[]) {
            if (memberTitleAliasResponse) {
              const memberTitleAlias = memberTitleAliasResponse.find(x => x.sourceMemberTitleId === userInfo.memberTitleId);
              if (memberTitleAlias) {
                userInfo.memberTitleId = memberTitleAlias.shoppingMemberTitleId;
                localStorage.setItem('appcoporate.userInfo', JSON.stringify(userInfo));
              }
            }
            getDiscountPercentages(transactionalWholeSaleQualified, transactionalOptin, userInfo.memberTitleId, storeId);
          });
        }
        else {
          getDiscountPercentages(transactionalWholeSaleQualified, transactionalOptin, userInfo.memberTitleId, storeId);
        }

      }).catch(function (err: any) {
        getDiscountPercentages(transactionalWholeSaleQualified, transactionalOptin, userInfo.memberTitleId, storeId);
      });
};


const loadStorePortalFeatures = (storeId: number, portalId: number) => {
  if (!storePortalFeaturesLoaded) {
    storePortalFeaturesLoaded = true;
    const storePortalFeaturesUrl = ApiUrlConstants.configurationApiUrl + 'stores/' +
      storeId + '/portals/' + portalId + '/features';
    const myHeaders = constructHttpheaders();
    const myInit = {
      method: 'GET',
      headers: myHeaders
    };
    fetch(storePortalFeaturesUrl, myInit)
      .then(
        function (response: any) {
          if (response && response.status !== 404 && response.status !== 204) {
            response.json().then(function (storePortalFeatures: StorePortalFeature[]) {
              if (storePortalFeatures !== undefined && storePortalFeatures !== null
                && storePortalFeatures.length !== 0) {
                localStorage.setItem('appcoporate.StorePortalFeatures', JSON.stringify(storePortalFeatures));
              }
            });
          }
        }).catch(function (err: any) {
        });
  }
}

function constructHttpheaders() {
  const myHeaders = new Headers();
  const uuid = SSO.getnonce();
  let headerValue = '';
  myHeaders.append('UUID', uuid);
  let token = getStoredToken(TokenType.ACCESS_TOKEN);
  if (!token) {
    token = localStorage.getItem('appcoporate.guestToken');
    headerValue = 'Bearer ' + token + '&&3';
    if (environment.enableAuthorization) {
      myHeaders.append('Authorization', getAuthorizationHeader(headerValue, uuid));
    }
    if (environment.enableAuthentication) {
      myHeaders.append('Authentication', headerValue);
    }
  } else {
    headerValue = 'Bearer ' + token + '&&2';
    if (environment.enableAuthorization) {
      myHeaders.append('Authorization', getAuthorizationHeader(headerValue, uuid));
    }
    if (environment.enableAuthentication) {
      myHeaders.append('Authentication', headerValue);
    }
  }
  return myHeaders;
}

function loadStoreConfiguration(storeInfo: any, modifyNavPath?: boolean): void {
  if (storeInfo) {
    storeInfo = getPreviewConfig(storeInfo);
    localStorage.setItem('appcoporate.StoreConfiguration', JSON.stringify(storeInfo));
    const storeData: StoreConfig = JSON.parse(JSON.stringify(storeInfo));
    let languageDisplayDirection = '';
    if (storeData && storeData.languages) {
      cookieService.set(CacheKey.CountryId, storeData.homeCountryId + '', cookieExpiryDate,
        environment.cookiePath, environment.cookieDomain);
      cookieService.set(CacheKey.countryCode, storeData.homeIsocodeThree.toLowerCase(),
        cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
      const languages: Language[] = storeData.languages;
      let defaultLanguage = '';
      if (languages && languages.length > 0) {
        const lang = cookieService.get(CacheKey.languageCode);
        if (lang && !localStorage.getItem('appcoporate.UserLoggedIn')) {
          localStorage.removeItem('appcoporate.CartSessionInfo');
          const check = languages.filter(x => x.cultureName.toLowerCase() === lang.toLowerCase());
          let defaultlang;
          let countryMetaData: CountryMetaData = JSON.parse(localStorage.getItem('appcoporate.CountryMetaData'));
          if (countryMetaData) {
            if (check.length === 0) {
              defaultlang = languages.find((x) => x.default === true) || languages[0];
            }
          }
          if (check.length === 0 && (defaultlang && defaultlang.length === 0)) {
            setFallbackCountryAndLanguage();
          }
        }
        const userInfo: Member = JSON.parse(localStorage.getItem('appcoporate.userInfo'));
        let storeDefault: Language;
        let userPreferenceLanguage: string;
        if (userInfo && userInfo.preferenceValue && userInfo.homeCountryCode
          && userInfo.homeCountryCode.toLowerCase() === storeData.homeIsocodeThree.toLowerCase()
          && localStorage.getItem('appcoporate.UserLoggedIn')) {
          localStorage.removeItem('appcoporate.UserLoggedIn');
          storeDefault = languages.find((x) => x.languageId === Number(userInfo.preferenceValue));
          if (storeDefault) {
            userPreferenceLanguage = storeDefault.cultureName;
            cookieService.set(CacheKey.languageCode, userPreferenceLanguage, cookieExpiryDate,
              environment.cookiePath, environment.cookieDomain);
          }
        }
        if (!storeDefault) {
          storeDefault = languages.find((x) => x.default === true) || languages[0];
        }
        defaultLanguage = storeDefault.cultureName;
        languageDisplayDirection = storeDefault.displayDirection;
        localStorage.setItem('appcoporate.DefaultLanguage', JSON.stringify(defaultLanguage));
        let selectedLanguage: string = cookieService.get(CacheKey.languageCode);
        if (selectedLanguage) {
          try {
            selectedLanguage = JSON.parse(selectedLanguage);
          } catch (e) {
            selectedLanguage = selectedLanguage;
          }
          let language = languages.find(x => x.cultureName == selectedLanguage);
          if (language) {
            languageDisplayDirection = language.displayDirection;
          }
        }
        if (!selectedLanguage ||
          (selectedLanguage && !languages.find((x: any) => x.cultureName.toLowerCase() === selectedLanguage.toLowerCase()))) {
          selectedLanguage = defaultLanguage;
          cookieService.set(CacheKey.languageCode, selectedLanguage, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
          cookieService.set(CacheKey.countryCode, storeData.homeIsocodeThree.toLowerCase(),
            cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
          canShowSplashInitally = false;
          let language = languages.find(x => x.cultureName == selectedLanguage);
          if (language) {
            languageDisplayDirection = language.displayDirection;
          }
        }
      }
      setLanguageDirectionCookie(languageDisplayDirection);
      setHtmlPageDisplayDirection();
    }
    bootstrapModule(modifyNavPath);
  }
}
/**
 * Get wholesale qualified details for a FPC / FBO based on memberID and countryCode
 * @param memberID
 * @param countryCode
 */
const getWholsesaleQualifiedDetails = async (fboID: string, countryCode: string) => {
  const accountServiceUrl = (ApiUrlConstants.accountApiUrl + '/wholesaleQualifiedEligibilityCheck?distributorId='
    + fboID + '&operatingCountry=' + countryCode);
  const myHeaders = new Headers();
  const requestInit = {
    method: 'GET',
    headers: myHeaders
  };
  fetch(accountServiceUrl, requestInit)
    .then(
      function (response: any) {
        const userInfo: any = JSON.parse(localStorage.getItem('appcoporate.userInfo'));
        if (response && response.status !== 404) {
          response.json().then(function (wholesaleResponse: WholesaleQualifiedResponse) {
            if (wholesaleResponse) {
              // User wholesale qualified eligibility check

              if (userInfo) {
                userInfo.transactionalWholesaleQualified = wholesaleResponse.wholesaleQualified
                  ? wholesaleResponse.wholesaleQualified : false;
                userInfo.transactionalOptin = wholesaleResponse.optIn ? wholesaleResponse.optIn : false;
                localStorage.setItem('appcoporate.userInfo', JSON.stringify(userInfo));
              }
            }
            if (userInfo) {
              getStoreConfiguration(userInfo.homeCountryCode);
            }
          });
        } else {
          if (userInfo) {
            getStoreConfiguration(userInfo.homeCountryCode);
          }
          getwholesaleOtpinValues();
        }
      }).catch(function (err: any) {
        getwholesaleOtpinValues();
        getStoreConfiguration();
      });
};

function validateResponse(payload: any, isRedirect: boolean, navPath: string) {
  try {
    if (payload.nonce !== cookieService.get(SSO.NONCE)) {
      // payload.nonce != JSON.parse(localStorage.getItem('appcoporate.id_nonce'))
      redirect(false);
      return false;
    } else {
      if ((payload && payload.userinfo && !payload.userinfo.userName) || (payload && !payload.userinfo)) {
        if (SSO.isRemoveObsoleteCookie()) {
          localStorage.removeItem(SSO.ACCESS_TOKEN);
          localStorage.removeItem(SSO.REFRESH_TOKEN);

          cookieService.delete(SSO.MEMBER_ID, apiConfig.cookiePath, apiConfig.cookieDomain);
          cookieService.delete(SSO.NONCE, apiConfig.cookiePath, apiConfig.cookieDomain);
        } else {
          cookieService.delete(SSO.ACCESS_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
          cookieService.delete(SSO.MEMBER_ID, apiConfig.cookiePath, apiConfig.cookieDomain);
          cookieService.delete(SSO.REFRESH_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
          cookieService.delete(SSO.NONCE, apiConfig.cookiePath, apiConfig.cookieDomain);
        }

        if (document.readyState !== 'loading') {
          document.getElementById('error-sso').style.display = 'block';
          document.getElementById('user_info_error').style.display = 'block';
          document.getElementById('in_error_reason').style.display = 'block';
          document.getElementById('progressBar').style.display = 'none';
          document.getElementById('other_error_reason').style.display = 'none';

        } else {
          document.addEventListener('DOMContentLoaded', function (event) {
            document.getElementById('error').style.display = 'block';
            document.getElementById('user_info_error').style.display = 'block';
            document.getElementById('in_error_reason').style.display = 'block';
            document.getElementById('progressBar').style.display = 'none';
            document.getElementById('other_error_reason').style.display = 'none';
          });
        }
        return false;
      }
      userLoginStatus = true;
      if (payload.userinfo && payload.userinfo.memberTypeId === MemberType.PREFERREDCUSTOMER
        && !payload.userinfo.wholesaleQualified && cookieService.get(CacheKey.FPCWholesaleQualified)) {
        payload.userinfo.wholesaleQualified = cookieService.get(CacheKey.FPCWholesaleQualified);
      }
      // wholesaleQualified must be false or true it should not be a null
      // we are checking the wholesaleQualified is null or not and assigning the default false value to it
      if (payload && payload.userinfo && !payload.userinfo.wholesaleQualified) {
        payload.userinfo.wholesaleQualified = false;
      }
      if (payload.userinfo && (payload.userinfo.memberTypeId === MemberType.PREFERREDCUSTOMER || payload.userinfo.memberTypeId === MemberType.DISTRIBUTOR)) {
        sessionStorage.removeItem(CacheKey.fboId);
      }
      loggedInMemberId = payload.userinfo.userName;
      localStorage.removeItem('appcoporate.guestUserEnabled');
      localStorage.removeItem('appcoporate.guestToken');
      cookieService.set(SSO.MEMBER_ID, payload.userinfo.userName, null, apiConfig.cookiePath, apiConfig.cookieDomain);
      cookieService.set(SSO.MEMBER_SESSION_STATE, payload.session_state, null, apiConfig.cookiePath, apiConfig.cookieDomain);
      localStorage.setItem('appcoporate.userInfo', JSON.stringify(payload.userinfo));
      localStorage.setItem('appcoporate.impersonatedUser', JSON.stringify(payload.impersonatedUser));
      localStorage.setItem('appcoporate.session_state', JSON.stringify(payload.session_state));
      localStorage.setItem('appcoporate.DocumentStatus', JSON.stringify(payload.documentState));
      // save the access token here
      const isNewToken: boolean = (localStorage.getItem(SSO.IS_NEW_TOKEN) === 'true');
      if (SSO.isRemoveObsoleteCookie() && isNewToken) {
        const accessToken = localStorage.getItem(SSO.ACCESS_TOKEN);
        const refreshToken = localStorage.getItem(SSO.REFRESH_TOKEN);
        const uuid = cookieService.get(SSO.MEMBER_SESSIONID);
        saveAccessToken(constructUserSession(accessToken, refreshToken, uuid), isRedirect, navPath);
      }
      return true;
    }
  } catch (err) {
    redirect(false);
    return false;
  }
}

function redirect(login_required: boolean) {
  if (SSO.isRemoveObsoleteCookie()) {
    removeSessionCookieAndTokens();
    cookieService.delete(SSO.NONCE, apiConfig.cookiePath, apiConfig.cookieDomain);
  } else {
    cookieService.delete(SSO.ACCESS_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
    cookieService.delete(SSO.REFRESH_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
    cookieService.delete(SSO.NONCE, apiConfig.cookiePath, apiConfig.cookieDomain);
  }


  const state = getnonce();
  const id_nonce = getnonce();
  cookieService.set(SSO.NONCE, id_nonce, null, apiConfig.cookiePath, apiConfig.cookieDomain);
  localStorage.setItem('appcoporate.state', JSON.stringify(state));
  if (!window.location.pathname.startsWith('/login')) {
    if (!window.location.pathname.toLowerCase().includes(SharedConstants.LegacyUrlWhitelistPhrase)) {
      localStorage.setItem('appcoporate.Nav_path',
        JSON.stringify(window.location.pathname + window.location.search));
    }
  } else {
    localStorage.removeItem('appcoporate.Nav_path');
    localStorage.removeItem('appcoporate.NavigateToShopCheckout');
  }
  window.location.href = apiConfig.ssoApiURL + '/auth?login_required=' +
    false + '&client_id=' + apiConfig.ssoClientID + '&redirect_uri=' + window.location.origin +
    '/login&scope=openid&response_type=code&state=' + state + '&nonce=' + id_nonce;
}

function checkAndLoadTokens() {
  const memberSessionId = cookieService.get(SSO.MEMBER_SESSIONID);
  const localMemberSessionId = localStorage.getItem(SSO.LOCAL_MEMBER_SESSION_ID);
  const accessToken = getStoredToken(TokenType.ACCESS_TOKEN);
  if (SSO.isRemoveObsoleteCookie()) {
    if (memberSessionId) {
      if (accessToken && memberSessionId === localMemberSessionId) {
        tokenCheck(false);
      } else {
        getUserSessionDetails();
      }
    } else {
      removeSessionCookieAndTokens();
      tokenCheck(false);
    }
  } else {
    tokenCheck(false);
  }
}

function tokenCheck(validateUuid: boolean) {
  // check if uuid available
  // if available then load
  if (validateUuid) {
    checkAndLoadTokens();
  } else {
    if (getStoredToken(TokenType.ACCESS_TOKEN)) {
      validateAccessToken(false, '');
    } else if (getStoredToken(TokenType.REFRESH_TOKEN)) {
      validateRefreshToken();
    } else {
      getGuestTokenBeforeLogin();
    }
  }
}

function loginProcess() {
  if ((!(window.location.href.indexOf('/login') > -1)) || (window.location.href.indexOf('/checkout/login') > -1)) {
    if (localStorage.getItem('InitialLoadCompleted') !== 'true') {
      if (window.location.pathname !== undefined
        && window.location.pathname !== null && window.location.pathname !== '') {
        if (!window.location.pathname.toLowerCase().includes(SharedConstants.LegacyUrlWhitelistPhrase)) {
          localStorage.setItem('appcoporate.Nav_path',
            JSON.stringify(window.location.pathname + window.location.search));
        }
      }
      // redirect(false);
    } else {
      localStorage.removeItem('InitialLoadCompleted');
    }
    getStoreConfiguration();
  } else {
    // let url =  getParamValueFromUrl('state',window.location.href);
    const state: string = getParamValueFromUrl('state', window.location.href);
    const code: string = getParamValueFromUrl('code', window.location.href);
    if (state && code) {
      if (state === JSON.parse(localStorage.getItem('appcoporate.state'))) {
        const payload = 'client_id=' + apiConfig.ssoClientID +
          '&client_assertion_type=urn:ietf:params:oauth:client-assertion-type:jwt-bearer&client_assertion='
          + apiConfig.ssoClientAssertion + '&code=' + code + '&grant_type=authorization_code&redirect_uri='
          + window.location.origin + '/login';
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-type', 'application/x-www-form-urlencoded');
        const fetchConfig = {
          headers: headers,
          method: 'POST',
          body: payload
        };
        fetch(apiConfig.ssoApiURL + '/token', fetchConfig).then(
          function (response: any) {
            if (response) {
              response.json().then(function (res: any) {
                if (SSO.isRemoveObsoleteCookie()) {
                  const guid = getnonce();
                  cookieService.set(SSO.MEMBER_SESSIONID, guid, null, apiConfig.cookiePath, apiConfig.cookieDomain);
                  localStorage.setItem(SSO.LOCAL_MEMBER_SESSION_ID, guid);
                  localStorage.setItem(SSO.ACCESS_TOKEN, res.access_token);
                  localStorage.setItem(SSO.REFRESH_TOKEN, res.refresh_token);
                  localStorage.setItem(SSO.IS_NEW_TOKEN, 'true');
                } else {
                  cookieService.set(SSO.ACCESS_TOKEN, res.access_token, null, apiConfig.cookiePath, apiConfig.cookieDomain);
                  cookieService.set(SSO.REFRESH_TOKEN, res.refresh_token, null, apiConfig.cookiePath, apiConfig.cookieDomain);
                }
                localStorage.setItem('appcoporate.UserLoggedIn', 'true');
                navigateAfterLogin();
              });
            }
          })
          .catch(function (err: any) {
            errorHandle('token_error');
          });
      } else {
        redirect(false);
      }
    } else {
      if (localStorage.getItem('InitialLoadCompleted') !== 'true') {
        localStorage.setItem('InitialLoadCompleted', 'true');
      }
      navigateAfterLogin();
    }
  }
}

function navigateAfterLogin() {
  if (localStorage.getItem('appcoporate.NavigateToShopCheckout')) {
    const navigateToShopCheckout = JSON.parse(localStorage.getItem('appcoporate.NavigateToShopCheckout'));
    localStorage.removeItem('appcoporate.NavigateToShopCheckout');
    window.location.href = environment.shopURL + navigateToShopCheckout;
  } else if (localStorage.getItem('appcoporate.Nav_path')) {
    const Nav_path = JSON.parse(localStorage.getItem('appcoporate.Nav_path'));
    localStorage.removeItem('appcoporate.Nav_path');
    if (Nav_path.split('/').indexOf('favorite') > -1) {
      validateAccessToken(true, Nav_path);
      // window.location.href = Nav_path + '?userLoggedIn=true';
    } else {
      if (Nav_path.includes(SharedConstants.LegacyUrlWhitelistPhrase)) {
        window.history.replaceState(null, null, decodeURIComponent(encodeURIComponent(window.location.origin)));
      }
      else {
        window.history.replaceState(null, null, decodeURIComponent(encodeURIComponent(window.location.origin + Nav_path)));
      }
      window.location.reload();
    }
    // window.location.href = window.location.origin + Nav_path;
  } else {
    window.location.href = window.location.origin;
  }
}

function validateAccessToken(isRedirect: boolean, navPath: string) {
  const access_token = getStoredToken(TokenType.ACCESS_TOKEN);
  const payloadData = 'client_id=' + apiConfig.ssoClientID +
    '&client_assertion_type=urn:ietf:params:oauth:client-assertion-type:jwt-bearer&client_assertion=' +
    apiConfig.ssoClientAssertion + '&token_type_hint=access_token&token=' + access_token;
  const headers = new Headers();
  headers.append('Accept', 'application/json');
  headers.append('Content-type', 'application/x-www-form-urlencoded');
  const fetchConfig = {
    headers: headers,
    method: 'POST',
    body: payloadData
  };
  fetch(apiConfig.ssoApiURL + '/token/introspect', fetchConfig).then(
    function (response: any) {
      if (response) {
        response.text().then(function (res: any) {
          const verifier = new IdTokenVerifier();
          const payload = verifier.decode(res).payload;
          if (validateResponse(payload, isRedirect, navPath)) {
            // Wholesale eligibility check for FPC/FBO users
            if (payload && payload.userinfo && payload.userinfo.memberTypeId
              && (payload.userinfo.memberTypeId === MemberType.PREFERREDCUSTOMER
                || payload.userinfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER
                || ((!payload.userinfo.wholesaleQualified || !payload.userinfo.optin)
                  && payload.userinfo.memberTypeId === MemberType.DISTRIBUTOR))) {
              getWholsesaleQualifiedDetails(payload.userinfo.distributorId, payload.userinfo.homeCountryCode);
            } else if (!isRedirect) {
              getwholesaleOtpinValues();
              getStoreConfiguration();
            }
          }
        });
      } else {
        redirect(false);
      }
    })
    .catch(function (err: any) {
      if (SSO.isRemoveObsoleteCookie()) {
        localStorage.removeItem(SSO.ACCESS_TOKEN);
      } else {
        cookieService.delete(SSO.ACCESS_TOKEN, apiConfig.cookiePath, apiConfig.cookieDomain);
      }
      if (getStoredToken(TokenType.REFRESH_TOKEN)) {
        validateRefreshToken();
      } else {
        loginProcess();
      }
    });
}

// To get the wholesale qualified and optin values from the wholesale eligibility check
function getwholesaleOtpinValues() {
  const userInfo: any = JSON.parse(localStorage.getItem('appcoporate.userInfo'));
  if (userInfo) {
    userInfo.transactionalWholesaleQualified = userInfo.wholesaleQualified ? userInfo.wholesaleQualified : false;
    userInfo.transactionalOptin = userInfo.optin ? userInfo.optin : false;
    localStorage.setItem('appcoporate.userInfo', JSON.stringify(userInfo));
  }
}

function redirection(navPath: string) {
  window.location.href = decodeURIComponent(encodeURIComponent(navPath + '?userLoggedIn=true'));
}

function validateRefreshToken() {
  // need for url three letter country code we will remove later
  const isoCountryCode = cookieService.get(CacheKey.countryCode) || 'usa';
  const refreshToken = getStoredToken(TokenType.REFRESH_TOKEN);
  const payload = 'client_id=' + apiConfig.ssoClientID +
    '&client_assertion_type=urn:ietf:params:oauth:client-assertion-type:jwt-bearer&client_assertion='
    + apiConfig.ssoClientAssertion + '&refresh_token='
    + refreshToken +
    '&grant_type=refresh_token&redirect_uri=' + window.location.origin + '/' + isoCountryCode + '/login';
  const headers = new Headers();
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/x-www-form-urlencoded');
  const fetchConfig: any = {
    headers: headers,
    method: 'POST',
    body: payload
  };
  fetch(apiConfig.ssoApiURL + '/token', fetchConfig).then(
    function (response: any) {
      if (response) {
        response.json().then(function (res: any) {
          if (SSO.isRemoveObsoleteCookie()) {
            const guid = getnonce();
            cookieService.set(SSO.MEMBER_SESSIONID, guid, null, apiConfig.cookiePath, apiConfig.cookieDomain);
            localStorage.setItem(SSO.LOCAL_MEMBER_SESSION_ID, guid);
            localStorage.setItem(SSO.ACCESS_TOKEN, res.access_token);
            localStorage.setItem(SSO.REFRESH_TOKEN, res.refresh_token);
            localStorage.setItem(SSO.IS_NEW_TOKEN, 'true');
          } else {
            cookieService.set(SSO.ACCESS_TOKEN, res.access_token, null, apiConfig.cookiePath, apiConfig.cookieDomain);
            cookieService.set(SSO.REFRESH_TOKEN, res.refresh_token, null, apiConfig.cookiePath, apiConfig.cookieDomain);
          }
          validateAccessToken(false, '');
        });
      }
    })
    .catch(function (err: any) {
      errorHandle('refresh_token_error');
    });
}

function getnonce() {
  let d = new Date().getTime();
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now();
  }
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // tslint:disable-next-line:no-bitwise
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    // tslint:disable-next-line:no-bitwise
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}

function getGuestTokenBeforeLogin() {
  localStorage.setItem('appcoporate.guestToken', environment.guestToken);
  localStorage.setItem('appcoporate.guestUserEnabled', 'true');
  loginProcess();
}

function getGuestTokenBeforeStoreConfig(loadPortalCountries: boolean) {
  localStorage.setItem('appcoporate.guestToken', environment.guestToken);
  localStorage.setItem('appcoporate.guestUserEnabled', 'true');
  if (loadPortalCountries) {
    getAllPortalCountries();
  }
}

function getParamValueFromUrl(searchParam: string, urlString: string) {
  const match = RegExp('[?&]' + searchParam + '=([^&]*)').exec(urlString);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function updateClientAssertion() {
  const baseUrl = environment.production ? window.location.origin : environment.corporateUrl;
  let url = baseUrl + '/api/Configuration?redirect=' + getnonce(); 
  url = url + '&expiryCode=' + new Date().getTime();
  fetch(url).then(
    function (response: any) {
      if (response) {
        response.json().then(function (res: any) {
          apiConfig.ssoClientAssertion = res.apiConfiguration.ssoClientAssertion;
          apiCheck();
        })
          .catch(function (err: any) {
          });
      }
    })
    .catch(function (err: any) {
    });
}

function checkClientAssertionValidity() {
  const clientAssertion = apiConfig.ssoClientAssertion;
  const verifier = new IdTokenVerifier();
  const exp = verifier.decode(clientAssertion).payload.exp;
  const presentEpochTime = Math.round((new Date()).getTime() / 1000);
  if (exp < presentEpochTime) {
    return false;
  } else {
    return true;
  }
}

function getPreviewConfig(storeData: StoreConfig): StoreConfig {
  const previewConfig: any = JSON.parse(localStorage.getItem('appcoporate.previewConfig'));
  if (storeData && previewConfig && previewConfig.countryLanguages
    && (environment.betaPortal || (!previewConfig.titanPlatformEnabled && environment.allCountriesCorporateEnabled))) {
    for (let i = 0; i < previewConfig.countryLanguages.length; i++) {
      previewConfig.countryLanguages[i].cultureName = previewConfig.countryLanguages[i].languageCulture;
    }
    storeData.languages = previewConfig.countryLanguages;
    storeData.homeIsocodeThree = previewConfig.isocodeThree;
    storeData.homeCountryId = previewConfig.id;
    storeData.countryId = previewConfig.id;
    storeData.operatingCountry = previewConfig.operatingCountry || storeData.operatingCountry;
  }
  return storeData;
}

function getAllPortalCountries() {
  const myHeaders = new Headers();
  const uuid = SSO.getnonce();
  let headerValue = '';
  myHeaders.append('UUID', uuid);
  let token = getStoredToken(TokenType.ACCESS_TOKEN);
  if (!token) {
    token = localStorage.getItem('appcoporate.guestToken');
    headerValue = 'Bearer ' + token + '&&3';
    if (environment.enableAuthorization) {
      myHeaders.append('Authorization', getAuthorizationHeader(headerValue, uuid));
    }
    if (environment.enableAuthentication) {
      myHeaders.append('Authentication', headerValue);
    }
  } else {
    headerValue = 'Bearer ' + token + '&&2';
    if (environment.enableAuthorization) {
      myHeaders.append('Authorization', getAuthorizationHeader(headerValue, uuid));
    }
    if (environment.enableAuthentication) {
      myHeaders.append('Authentication', headerValue);
    }
  }
  const myInit = {
    method: 'GET',
    headers: myHeaders
  };
  fetch(ApiUrlConstants.configurationApiUrl + 'portals/' + MenuPortal.Corporate + '/countries', myInit)
    .then(
      function (response: any) {
        if (response) {
          response.json().then(function (portalCountries: PortalCountry[]) {
            try {
              if (portalCountries && portalCountries.length > 0) {
                if (environment.betaPortal === false && getBetaCountries().length > 0) {
                  portalCountries = updateTitanPlatformFlagsForBetaCountries(portalCountries);
                }
                validateCountryTitanPlatformEnabledOrNot(portalCountries);
              }
            }
            catch (err) {
              console.log(err);
            }

          }).catch(function (err: any) {
            console.error(err);
          });
        }
      })
    .catch(function (err: any) {
    });
}


function updateTitanPlatformFlagsForBetaCountries(regions: Array<PortalCountry>) {
  let betaEnabledCountries: Array<string> = getBetaCountries();
  if (regions !== null && regions !== undefined && regions.length > 0) {
    for (let region of regions) {
      if (region.countries !== null && region.countries !== undefined && region.countries.length > 0) {
        for (let country of region.countries) {
          if (betaEnabledCountries.includes(country.isocodeThree.toLowerCase())) {
            country.titanPlatformEnabled = false;
          }
        }
      }
    }
  }
  return regions;
}


function validateCountryTitanPlatformEnabledOrNot(portalCountries: PortalCountry[]) {
  if (portalCountries && portalCountries.length > 0) {
    localStorage.setItem('appcoporate.portalCountries', JSON.stringify(portalCountries));
    countries = flatten(portalCountries.map(portal => portal.countries));
    if (!cookieService.get(CacheKey.countryCode) && apiConfig.countryCode) {
      cookieService.set(CacheKey.countryCode, apiConfig.countryCode,
        cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
    }
    if (cookieService.get(CacheKey.countryCode)) {
      const countryCode = cookieService.get(CacheKey.countryCode);
      const country = countries.find(item => item.isocodeThree.toLowerCase() === countryCode.toLowerCase());
      if (country && country.titanPlatformEnabled && !environment.betaPortal) {
        getStoreConfiguration();
      } else {
        const languageCode = country && country.defaultLangName ? country.defaultLangName.split('-')[0] : 'en';
        cookieService.set(CacheKey.SplashScreen, 'false', cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
        const shareFBOID = sessionStorage.getItem(CacheKey.fboId);
        let redirectUrl = window.location.origin + '/page/home-page/' + country.isocodeThree.toLowerCase() + '/' + languageCode;
        if (shareFBOID) {
          redirectUrl = redirectUrl + '?distribID=' + shareFBOID;
        }
        window.location.href = redirectUrl;
      }
    } else {
      setFallbackCountryAndLanguage();
    }
  }
}
/**
 * @description To Check a standalone page
 * @author njagadeesan
 * @date 2020-03-24
 * @param {*} url
 * @returns {boolean}
 */
function isEventsPage(url) {
  if (url) {
    const eventPage = SharedConstants.EVENT_PAGES.find((page) => {
      return url.toLowerCase().indexOf(page.toLowerCase()) > -1;
    });
    return eventPage;
  }
  return null;
}

const apiCheck = function () {
  setHtmlPageDisplayDirection();
  const memberSalePromotionModel = cookieService.get(CacheKey.MemberSalePromotionModel);
  if (memberSalePromotionModel) {
    sessionStorage.setItem('memberSalePromotionModel', memberSalePromotionModel);
    cookieService.delete(CacheKey.MemberSalePromotionModel);
  }
  if (isEventsPage(window.location.href)) {
    const userInfo: Member = JSON.parse(localStorage.getItem('appcoporate.userInfo'));
    if (!userInfo) {
      localStorage.setItem('appcoporate.guestToken', environment.guestToken);
      localStorage.setItem('appcoporate.guestUserEnabled', 'true');
    }
    bootstrapModule(false);
  } else {
    let countryCode;
    let langCode;
    countryCode = cookieService.get(CacheKey.countryCode);
    langCode = cookieService.get(CacheKey.languageCode);
    // read fbo id from host url for replicated site domain
    if (window.location.host && window.location.host.indexOf('.fbo.') > -1) {
      const hostUrl: string = window.location.host;
      const hostUrlArr: string[] = hostUrl.split('.');
      if (hostUrlArr && hostUrlArr.length > 0 && !Number.isNaN(parseInt(hostUrlArr[0], 10))) {
        const fboIdValue = hostUrlArr[0].replace(/\"/g, '');
        sessionStorage.setItem(CacheKey.fboId, fboIdValue);
        // cookieService.set(CacheKey.fboId, fboIdValue, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
      }
    }
    // When navigated from Legacy to Titan
    const shareFBOID = cookieService.get(CacheKey.fboId);
    if (shareFBOID) {
      sessionStorage.setItem('fboId', shareFBOID);
      cookieService.delete(CacheKey.fboId, apiConfig.cookiePath, apiConfig.cookieDomain);
    }
    // const shareFBOID = JSON.parse(localStorage.getItem('appcoporate.fboId'));
    // if (shareFBOID) {
    //   cookieService.set(CacheKey.fboId, shareFBOID, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
    //   localStorage.removeItem('appcoporate.fboId');
    // }
    if (!window.location.pathname.startsWith('/login')) {
      if (localStorage.getItem('appcoporate.NavigateToShopCheckout')) {
        localStorage.removeItem('appcoporate.NavigateToShopCheckout');
      }
      const urlPath = window.location.pathname.split('/');
      let countryCodeInUrl = urlPath[1];
      let langCodeInUrl = '';
      if (urlPath[2] && countryCodeInUrl) {
        const lang = urlPath[2].split('-');
        if (lang && lang.length > 1) {
          lang[lang.length - 1] = lang[lang.length - 1].toUpperCase();
        }
        langCodeInUrl = lang.join('-');
      }
      if (langCode && countryCodeInUrl) {
        const storeLanguageCode = langCode.split("-");
        const countryInLanguageCode = storeLanguageCode[storeLanguageCode.length - 1];
        if (langCodeInUrl && langCode && langCodeInUrl.toLowerCase() == langCode.toLowerCase() && countryInLanguageCode === countryInLanguageCode.toUpperCase()) {
          langCodeInUrl = langCode;
        }
      }
      if (countryCodeInUrl && countryCodeInUrl.length === 3 && langCodeInUrl) {
        countryCode = countryCodeInUrl;
        langCode = langCodeInUrl;
        cookieService.set(CacheKey.countryCode, countryCodeInUrl, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
        cookieService.set(CacheKey.languageCode, langCodeInUrl, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
      } else if (!isEventsPage(window.location.href)) {
        countryCodeInUrl = cookieService.get(CacheKey.countryCode);
        langCodeInUrl = cookieService.get(CacheKey.languageCode);
        if (countryCodeInUrl && langCodeInUrl && window && window.location
          && window.location.pathname && window.location.pathname.length > 2) {
          window.history.replaceState(null, null, countryCodeInUrl + '/'
            + langCodeInUrl + window.location.pathname + window.location.search);
        }
      }
    }
    canShowSplashInitally = cookieService.get(CacheKey.SplashScreen) || (countryCode && langCode) ? false : true;
    if (!canShowSplashInitally) {
      if (apiConfig) {
        if (checkClientAssertionValidity()) {
          tokenCheck(true);
        } else {
          updateClientAssertion();
        }
      } else {
        setTimeout(function () {
          apiCheck();
        }, 2000);
      }
    } else {
      getGuestTokenBeforeStoreConfig(true);
    }
  }
};

/**
 * returns the stored token
 */
function getStoredToken(tokenType: TokenType) {
  let token = '';
  let tokenKey = '';
  if (tokenType === TokenType.ACCESS_TOKEN) {
    tokenKey = SSO.ACCESS_TOKEN;
  } else {
    tokenKey = SSO.REFRESH_TOKEN;
  }
  if (SSO.isRemoveObsoleteCookie()) {
    const memberSessionId = cookieService.get(SSO.MEMBER_SESSIONID);
    const localMemberSessionId = localStorage.getItem(SSO.LOCAL_MEMBER_SESSION_ID);
    if (memberSessionId) {
      if (memberSessionId === localMemberSessionId) {
        token = localStorage.getItem(tokenKey);
      }
    }
  } else {
    token = cookieService.get(tokenKey);
  }
  return token;
}

function setLanguageDirectionCookie(displayDirection: string) {
  if (displayDirection !== '' && displayDirection !== undefined && displayDirection !== null) {
    cookieService.set(CacheKey.LanguageDisplayDirection, displayDirection, cookieExpiryDate,
      environment.cookiePath, environment.cookieDomain);
  }
}

function setHtmlPageDisplayDirection(displayDirection: string = '') {
  let direction = '';
  if (displayDirection) {
    direction = displayDirection;
  }
  else {
    direction = cookieService.get(CacheKey.LanguageDisplayDirection);
  }
  var docbody = document.body;
  if (direction) {
    document.getElementsByTagName('html')[0].setAttribute('dir', direction);
    docbody.classList.add('direction-' + direction);
  }
  else {
    document.getElementsByTagName('html')[0].setAttribute('dir', DisplayDirection.LTR);
    docbody.classList.add('direction-' + DisplayDirection.LTR);
  }
}
apiCheck();
